import { pilotV3 } from '~/services/serviceInstances';
import { RbacPermission } from '~/types/Rbac';

type BulkCheckPermissionResponse = {
  data: {
    type: 'permission_check';
    attributes: {
      results: Record<string, Record<string, boolean>>;
    };
  };
};

export const checkPermissionsBulk = async (
  permissions: RbacPermission[],
): Promise<Record<string, Record<string, boolean>>> => {
  const response = await pilotV3.post<BulkCheckPermissionResponse>(
    '/permission/bulk/',
    {
      data: {
        type: 'permission_check',
        attributes: {
          checks: permissions.map(({ resourceId, resourceType }) => ({
            resource_id: resourceId,
            resource_type: resourceType,
          })),
        },
      },
    },
  );
  return response.data.attributes.results;
};
